import type { EdgeType } from "../types/graph";

export interface EdgeStyle {
  color: string;
  width: number;
  dashPattern: number[] | null; // null = solid
  opacity: number;
}

export interface LegendEntry {
  label: string;
  color: string;
  dashPattern: number[] | null;
}

const EDGE_STYLES: Record<EdgeType, EdgeStyle> = {
  CALLS: { color: "#58a6ff", width: 1, dashPattern: null, opacity: 0.6 },
  IMPORTS: { color: "#7d8590", width: 1, dashPattern: null, opacity: 0.6 },
  HTTP_CALLS: { color: "#f85149", width: 2, dashPattern: [5, 5], opacity: 0.6 },
  CROSS_CALLS: { color: "#d29922", width: 2, dashPattern: [5, 5], opacity: 0.6 },
  EMITS: { color: "#3fb950", width: 1, dashPattern: [2, 2], opacity: 0.6 },
  LISTENS_ON: { color: "#39d2c0", width: 1, dashPattern: [2, 2], opacity: 0.6 },
  INHERITS: { color: "#a371f7", width: 1.5, dashPattern: null, opacity: 0.6 },
  IMPLEMENTS: { color: "#79c0ff", width: 1.5, dashPattern: null, opacity: 0.6 },
  DEPLOYS: { color: "#d2a8ff", width: 1.5, dashPattern: [5, 5], opacity: 0.6 },
  OVERLAYS: { color: "#f0883e", width: 1, dashPattern: [2, 2], opacity: 0.6 },
};

const DEFAULT_EDGE_STYLE: EdgeStyle = {
  color: "#7d8590",
  width: 1,
  dashPattern: null,
  opacity: 0.6,
};

/**
 * Returns the visual style for a given edge type.
 * Falls back to a default gray solid style for unknown types.
 */
export function getEdgeStyle(edgeType: string): EdgeStyle {
  return EDGE_STYLES[edgeType as EdgeType] ?? DEFAULT_EDGE_STYLE;
}

/**
 * Returns legend entries for the given set of edge types.
 * Each entry includes the type label, color, and dash pattern.
 */
export function getEdgeLegendEntries(edgeTypes: string[]): LegendEntry[] {
  return edgeTypes.map((type) => {
    const style = getEdgeStyle(type);
    return {
      label: type,
      color: style.color,
      dashPattern: style.dashPattern,
    };
  });
}
